import React from 'react'
import { PlanLists } from '../components'

export default function SubscriptionPlan() {
    return (
        <div>
            <PlanLists />
        </div>
    )
}
